export interface CartSettings {
  cartData: any;
  originalOrderSummary: any;
  currentOrderSummary: any;

  inputCodeStatus: 'success' | 'fail' | 'unset' | 'loading';
  staffInfo: {
    staffName: string;
    tableNumber: string | number;
    customerName?: string;
    specialRequest?: string;
  };
  selectedRemoveItem: any;

  staffInputInfo:
    | {
        staffName?: string;
        staffInputCode?: string;
      }
    | false;
}

export default {
  inputCodeStatus: 'unset',
  staffInputInfo: {},
} as CartSettings;

export const spaceName = 'caCart';
